import useAuthentication from "@hooks/useAuthentication";
import { FC } from "react";
import PatientReportv1 from "./v1";
import PatientReportv2 from "./v2";

const AppointmentListReport: FC = () => {
  const { user } = useAuthentication();
  const whichVersion = user?.appointlistreport;
  if (whichVersion === "NORMAL_APPOINTMENTLIST_REPORT") {
    return <PatientReportv1 />;
  } else {
    return <PatientReportv2 />;
  }
};

export default AppointmentListReport;
